import { Button } from '@/components/ui/button';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { useEarlyAdopter } from '@/contexts/EarlyAdopterContext';
import { createEarlyAdopterHandler } from '@/utils/earlyAdopterInterceptor';
import featuresHero from '@/assets/features-hero.jpg';

const HeroSection = () => {
  const { openModal } = useEarlyAdopter();

  return (
    <div className="relative min-h-[600px] lg:min-h-[700px] flex items-center overflow-hidden">
      {/* Full-width background image */}
      <img
        src={featuresHero}
        alt="Older adult living confidently and independently at home"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Directional gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>

      <div className="relative container mx-auto px-4 py-24 lg:py-32">
        <div className="max-w-2xl space-y-8">
          <div className="inline-block bg-black/40 backdrop-blur-sm rounded-2xl p-8 lg:p-10 space-y-6">
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-hero">
              Everything You Need to Thrive at Home,{' '}
              <span className="text-primary">In One Connected Experience</span>
            </h1>

            <p className="text-lg lg:text-xl text-white/85 leading-relaxed">
              SeniorThrive brings wellness, home safety, and support together so daily life at home stays confident, connected, and in your control.
            </p>

            <p className="text-base text-white/70 italic">
              One system. One experience.
              Designed for real life at home.
            </p>

            <div className="pt-2">
              <Button
                size="lg"
                variant="gradient"
                className="text-lg px-10 hover-scale"
                onClick={createEarlyAdopterHandler(openModal, 'Features Hero - Get Started')}
              >
                Get Started
                <ArrowRightIcon className="ml-2 w-5 h-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
